import { render, staticRenderFns } from "./AutocompleteClassroom.vue?vue&type=template&id=87e2aafe&scoped=true"
import script from "./AutocompleteClassroom.vue?vue&type=script&lang=js"
export * from "./AutocompleteClassroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e2aafe",
  null
  
)

export default component.exports